/*
  Список, который вносят руками на карточке счёта: начисления, оплаты, проживающие,
  состав должников (20.10.2026).

  Хук знает про сервер и состояние, экран получает готовое (правило 1 скилла
  `frontend`). `load` обязан быть устойчивым между отрисовками (`useCallback`):
  иначе список грузился бы заново на каждую.

  После внесения, правки и удаления экран зовёт `reload`: список перечитывается с
  сервера, а не правится на месте, - показывается то, что записано, а не набрано
  (суммы и доли сервер приводит к своему виду).
*/

import { useCallback, useEffect, useState } from 'react'

export default function useEntryList(load) {
  const [state, setState] = useState({ rows: null, error: null })

  const reload = useCallback(() => {
    load()
      .then((rows) => setState({ rows, error: null }))
      .catch((error) => setState({ rows: null, error }))
  }, [load])

  useEffect(() => {
    reload()
  }, [reload])

  return { rows: state.rows, error: state.error, reload }
}
